import { CheckCircle, IconProps, Pencil, XCircle } from "@phosphor-icons/react";
import { Button, Color, Size, Variant } from "../../../components/Buttons";
import { ContactModal } from "../../../components/Modals/ContactModal";
import { PageTitle } from "../../../components/PageTitle";
import { Action, Header, Table } from "../../../components/Table";
import { useContactController } from "../../../controllers/contactController";
import { UserRole } from "../../../models/User";
import { Contact } from "../../../models/Contact";
import { TopView } from "./styles";
import { IconButton, Shape } from "../../../components/Buttons/IconButton";
import { formatPhoneByDDI } from "../../../helpers/phoneHelper";

const onlineIconProps: IconProps = {
  size: 24,
  weight: "duotone"
};

const headers: Array<Header<Contact>> = [
  {
    label: "Nome",
    key: "name",
    roles: [ UserRole.ADMIN, UserRole.MANAGER ]
  },
  {
    label: "Telefone",
    key: "phone",
    nested: ( row ) => formatPhoneByDDI( row.phone ),
    roles: [ UserRole.ADMIN, UserRole.MANAGER ]
  },
  {
    label: "Atendimentos",
    key: "chat",
    nested: ( row ) => row.chat?.services?.length.toString() ?? '-',
    roles: [ UserRole.ADMIN, UserRole.MANAGER ],
    align: "center",
    maxPossibleWidth: false,
  },
  {
    label: "Online",
    key: "isOnline",
    roles: [ UserRole.ADMIN, UserRole.MANAGER ],
    align: "center",
    maxPossibleWidth: false,
    component: ( contact ) => (
      <IconButton
        color={ ( contact.isOnline ? "success" : "text" ) as Color }
        shape={ Shape.CIRCLE }
      >
        { contact.isOnline ? <CheckCircle { ...onlineIconProps }/> : <XCircle { ...onlineIconProps }/> }
      </IconButton>
    ),
  },
];

export const Contacts = () => {
  const {
    page,
    perPage,
    total,
    search,
    contacts,
    loadingContacts,
    contact,
    openContactModal,
    changePage,
    changeSearch,
    handleToggleOpenContactModal,
    handleContact,
  } = useContactController();

  const actions: Array<Action<Contact>> = [
    {
      icon: Pencil,
      label: "Editar",
      color: "text",
      onClick: handleContact,
    },
  ];

  return (
    <>
      <TopView>
        <PageTitle>Contatos</PageTitle>

        <Button
          $variant={ Variant.CONTAINED }
          $color="text"
          $size={ Size.MEDIUM }
          onClick={ handleToggleOpenContactModal }
        >
          Adicionar
        </Button>
      </TopView>

      <Table<Contact>
        keyProperty="id"
        changePage={ changePage }
        page={ page }
        perPage={ perPage }
        total={ total }
        loading={ loadingContacts }
        data={ contacts }
        headers={ headers }
        actions={ actions }
        search={{
          value: search,
          placeholder: "Buscar por nome ou telefone",
          onChange: changeSearch,
        }}
      />

      <ContactModal
        open={ openContactModal }
        onClose={ handleToggleOpenContactModal }
        contact={ contact }
      />
    </>
  );
};
